import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { WindowRef } from './window/window-ref';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class CarouselService {
  private winRef = inject(WindowRef);

  getItemsPerSlide(
    nativeElement: HTMLElement,
    itemWidth: string,
  ): Observable<number> {
    return this.winRef.resize$.pipe(
      map(() => (nativeElement as HTMLElement).clientWidth),
      distinctUntilChanged(),
      map((totalWidth) => this.calculateItems(totalWidth, itemWidth)),
    );
  }

  private calculateItems(availableWidth: number, itemWidth: string) {
    let calculatedItems = 0;
    if (itemWidth.endsWith('px')) {
      const num = itemWidth.substring(0, itemWidth.length - 2);
      calculatedItems = availableWidth / <number>(<any>num);
    }

    if (itemWidth.endsWith('%')) {
      const perc = itemWidth.substring(0, itemWidth.length - 1);
      calculatedItems =
        availableWidth / (availableWidth * (<number>(<any>perc) / 100));
    }

    return Math.floor(calculatedItems) || 1;
  }
}
